module.exports = __webpack_public_path__ + "workspace/static/img/externalIDPTwo.63c1695.png";